import { computed, ref } from 'vue'

import { PROBABILITIES, CONSEQUENCES } from '@/constants/degree-of-risk-utils.constants.js'

const noncompliance_model_probabilities = ref([])
const noncompliance_model_consequences = ref([])

export default function useDegreeOfRisk() {
  const listProbabilities = () => {
    noncompliance_model_probabilities.value = Object.keys(PROBABILITIES).map(key => { return { 'name': PROBABILITIES[key], 'value': key }})
  }

  const listConsequences = () => {
    noncompliance_model_consequences.value = Object.keys(CONSEQUENCES).map(key => { return { 'name': CONSEQUENCES[key], 'value': key }})
  }

  const calculateDegreeOfRisk = (probability, consequences) => {
    const table = {
      1: { 1: 1, 2: 1, 3: 2, 4: 2, 5: 3 },
      2: { 1: 1, 2: 2, 3: 3, 4: 3, 5: 3 },
      3: { 1: 2, 2: 3, 3: 3, 4: 4, 5: 4 },
      4: { 1: 3, 2: 4, 3: 4, 4: 5, 5: 5 },
      5: { 1: 4, 2: 4, 3: 5, 4: 5, 5: 5 },
    }

    return table[consequences][probability];
  }

  const getRiskColor = risk => {
    const colors = {
      0: '#abd4ff',
      1: '#c6dfb5',
      2: '#19af54',
      3: '#fffd38',
      4: '#febf2d',
      5: '#fc0d1b',
    }

    return colors[risk];
  }

  return {
    listProbabilities,
    listConsequences,
    noncompliance_model_probabilities: computed(
      () => noncompliance_model_probabilities.value
    ),
    noncompliance_model_consequences: computed(
      () => noncompliance_model_consequences.value
    ),
    calculateDegreeOfRisk,
    getRiskColor,
  }
}
